var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 20,
    viewBox: "0 0 58 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.9999 10.3335C57.9999 6.91551 56.3439 4.21851 53.1788 4.21851C50.0003 4.21851 48.0771 6.91551 48.0771 10.3068C48.0771 14.3256 50.3475 16.355 53.6061 16.355C55.1954 16.355 56.3973 15.9945 57.3054 15.4872V12.8169C56.3973 13.2708 55.3556 13.5512 54.0335 13.5512C52.738 13.5512 51.5895 13.0973 51.4426 11.5218H57.9732C57.9732 11.3482 57.9999 10.6539 57.9999 10.3335ZM51.4025 9.06511C51.4025 7.55639 52.324 6.92886 53.1654 6.92886C53.98 6.92886 54.8481 7.55639 54.8481 9.06511H51.4025Z",
    fill: "#635BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.6668 4.21851C39.358 4.21851 38.5166 4.83268 38.0492 5.25992L37.8756 4.43213H34.9375V20L38.2762 19.2924L38.2896 15.5139C38.7704 15.861 39.4782 16.355 40.6534 16.355C43.044 16.355 45.2208 14.4324 45.2208 10.2C45.2075 6.32805 43.0039 4.21851 40.6668 4.21851ZM39.8655 13.4177C39.0775 13.4177 38.6101 13.1373 38.2896 12.7902L38.2762 7.83677C38.6235 7.44957 39.1043 7.18254 39.8655 7.18254C41.0808 7.18254 41.9222 8.5444 41.9222 10.2934C41.9222 12.0826 41.0941 13.4177 39.8655 13.4177Z",
    fill: "#635BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7246 3.43134L32.0767 2.71036V0L28.7246 0.70763V3.43134Z",
    fill: "#635BFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0767 4.44592H28.7246V16.1285H32.0767V4.44592Z",
    fill: "#635BFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0871 5.43416L22.8734 4.44615H19.9888V16.1287H23.3275V8.21127C24.1155 7.18321 25.451 7.37013 25.865 7.51699V4.44615C25.4376 4.28593 23.8751 3.99219 23.0871 5.43416Z",
    fill: "#635BFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6089 1.54895L11.3503 2.24323L11.3369 12.9378C11.3369 14.9138 12.8193 16.3691 14.7959 16.3691C15.891 16.3691 16.6923 16.1689 17.133 15.9285V13.2182C16.7056 13.3917 14.5955 14.0059 14.5955 12.0299V7.2901H17.133V4.44623H14.5955L14.6089 1.54895Z",
    fill: "#635BFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37881 7.83689C3.37881 7.31618 3.80617 7.11591 4.51399 7.11591C5.52896 7.11591 6.81104 7.42299 7.82602 7.97041V4.8328C6.71756 4.3922 5.62245 4.21863 4.51399 4.21863C1.80292 4.21863 0 5.63389 0 7.99711C0 11.6821 5.07489 11.0947 5.07489 12.6835C5.07489 13.2977 4.54069 13.4979 3.79282 13.4979C2.68435 13.4979 1.26872 13.044 0.146905 12.4298V15.6075C1.38892 16.1415 2.64429 16.3685 3.79282 16.3685C6.57065 16.3685 8.48041 14.9933 8.48041 12.6034C8.46706 8.62463 3.37881 9.33226 3.37881 7.83689Z",
    fill: "#635BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewStripe);
export default __webpack_public_path__ + "static/media/new-stripe.371473501a6e9b337dd960626a10d35a.svg";
export { ForwardRef as ReactComponent };